export default __webpack_public_path__ + "static/media/netcomet2.4cd4f61c.png";